export const EditwriteIcon = ({ ...props }) => {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
        <path d="m11 3h-6c-1.10457 0-2 .89543-2 2v14c0 1.1046.89543 2 2 2h14c1.1046 0 2-.8954 2-2v-6" />
        <path d="m9.5 11.5 8-8c.8284-.82843 2.1716-.82843 3 0s.8284 2.17157 0 3l-8 8-4.5 1.5z" />
      </g>
    </svg>
  );
};
